import request from '@/utlis/request'

export function findSysUsersPage(data) {
    return request({
        url: '/admin/sysuser/findSysUsersPage',
        method: 'POST',
        data
    })
}

/**
 * 新增用户(如果传id是编辑，不传是保存)
 */
export function saveSysUser(data) {
    return request({
        url: '/admin/sysuser/saveSysUser',
        method: 'POST',
        data
    })
}

/**
 * 查询机构列表
 */
export function findAllInstitution(data) {
    return request({
        url: '/admin/institution/findAllInstitution',
        method: 'post',
        data
    })
}

/**
 * 根据id查询用户详情
 */
export function findSysUserById(id) {
    return request({
        url: '/admin/sysuser/findSysUserById',
        method: 'get',
        params: {
            id
        }
    })
}

/**
 * 批量禁用/启用
 */
export function batchUpdateStatus(data) {
    return request({
        url: '/admin/sysuser/batchUpdateStatus',
        method: 'post',
        data
    })
}

/**
 * 重置密码
 */
export function resetPassword(data) {
    return request({
        url: '/admin/sysuser/resetPassword',
        method: 'post',
        data
    })
}